module.exports = __webpack_public_path__ + "i/ff6a823eabd85e67c626d007c2830bd5.png";